import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Project } from '@phrasewright/types';

export interface ProjectState {
  currentProject: Project | null;
  recentProjects: Project[];
  loading: boolean;
  error: string | null;
}

const initialState: ProjectState = {
  currentProject: null,
  recentProjects: [],
  loading: false,
  error: null,
};

const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    setCurrentProject: (state, action: PayloadAction<Project | null>) => {
      state.currentProject = action.payload;
      state.error = null;
    },
    addRecentProject: (state, action: PayloadAction<Project>) => {
      const existing = state.recentProjects.findIndex(
        (p) => p.id === action.payload.id
      );
      if (existing !== -1) {
        state.recentProjects.splice(existing, 1);
      }
      state.recentProjects.unshift(action.payload);
      state.recentProjects = state.recentProjects.slice(0, 10); // Keep only 10 recent
    },
    removeRecentProject: (state, action: PayloadAction<string>) => {
      state.recentProjects = state.recentProjects.filter(
        (p) => p.id !== action.payload
      );
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const {
  setCurrentProject,
  addRecentProject,
  removeRecentProject,
  setLoading,
  setError,
} = projectSlice.actions;

export const projectReducer = projectSlice.reducer;
